export default function mapIndices (source, indices) {
	const out = [];

	for (let i = 0, l = indices.length; i < l; i++) {
		out[i] = source[indices[i]];
	}

	return out;
}



// WEBPACK FOOTER //
// ./node_modules/moment-timezone/src/unpack/map-indices.js